import React from "react";
import { DefaultFooter } from "@ant-design/pro-components";

export default () => (
  <DefaultFooter
    copyright="2025 Power By EDOCDATA"
    links={[
      {
        key: "",
        title: "",
        href: "",
        blankTarget: true,
      },
    ]}
  />
);
